import React from 'react';
import { ITextFieldProps, TextField } from '../../../../../../ui';
import { useTranslation } from '../../../../../shared/i18n/translate/useTranslation';
import { useDetailsFormContext } from '../hooks/useDetailsFormContext';

export const ZipCode = (props: Partial<ITextFieldProps>) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
	} = useDetailsFormContext();

	return (
		<TextField
			label={t('parking_details_form_zip_code_label')}
			placeholder={t('parking_details_form_zip_code_placeholder')}
			invalid={!!errors.zipCode}
			error={errors.zipCode?.message}
			autoComplete="postal-code"
			{...props}
			{...register('zipCode')}
		/>
	);
};
